import { request, success, failure, USER_ROLES } from "./utilities";
import { getUserRoles, addNewUserRole, removeUserRole } from "../api";

const data = [
    {
        userRoleId: 0,
        roleName: "Master Super Admin",
    },
    {
        userRoleId: 1,
        roleName: "Employee"
    },
    {
        userRoleId: 2,
        roleName: 'EmployeeAdmin'
    },
    {
        userRoleId: 3,
        roleName: "Organization Admin"
    },
    {
        userRoleId: 4,
        roleName: 'Client'
    },
    {
        userRoleId: 5,
        roleName: "Freelancer"
    }
]

export function getAllUserRoles() {
    return (dispatch) => {
        dispatch(request(USER_ROLES.GET_ALL_USER_ROLES_REQUEST));
        dispatch(success(USER_ROLES.GET_ALL_USER_ROLES_SUCCESS, data));
        // getUserRoles().then((res) => {
        //     if (res.data.status === 1) {
        //         dispatch(success(USER_ROLES.GET_ALL_USER_ROLES_SUCCESS, res.data.data));
        //     }
        //     else {
        //         dispatch(failure(USER_ROLES.GET_ALL_USER_ROLES_FAILURE, res.data.message));
        //     }
        // }, (error) => {
        //     dispatch(failure(USER_ROLES.GET_ALL_USER_ROLES_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        // })
    }
}

export function addUserRole(userData, close) {
    return (dispatch) => {
        dispatch(request(USER_ROLES.ADD_NEW_USER_ROLE_REQUEST));
        addNewUserRole(userData).then((res) => {
            if (res.data.status === 1) {
                dispatch(success(USER_ROLES.ADD_NEW_USER_ROLE_SUCCESS, res.data.data));
                if (close) {
                    close();
                }
            }
            else {
                dispatch(failure(USER_ROLES.ADD_NEW_USER_ROLE_FAILURE, res.data.message));
            }
        }, (error) => {
            dispatch(failure(USER_ROLES.ADD_NEW_USER_ROLE_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        })
    }
}

export function editUserRole(userData, close) {
    return (dispatch) => {
        dispatch(request(USER_ROLES.EDIT_USER_ROLE_REQUEST));
        addNewUserRole(userData).then((res) => {
            if (res.data.status === 1) {
                dispatch(success(USER_ROLES.EDIT_USER_ROLE_SUCCESS, res.data.data));
                if (close) {
                    close();
                }
            }
            else {
                dispatch(failure(USER_ROLES.EDIT_USER_ROLE_FAILURE, res.data.message));
            }
        }, (error) => {
            dispatch(failure(USER_ROLES.EDIT_USER_ROLE_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        })
    }
}

export function deleteUserRole(userid) {
    return (dispatch) => {
        dispatch(request(USER_ROLES.DELETE_USER_ROLE_REQUEST));
        dispatch(success(USER_ROLES.DELETE_USER_ROLE_SUCCESS, userid));
        // removeUserRole(userid).then((res) => {
        //     if (res.data.status === 1) {
        //         dispatch(success(USER_ROLES.DELETE_USER_ROLE_SUCCESS, res.data.data));
        //     }
        //     else {
        //         dispatch(failure(USER_ROLES.EDIT_USER_ROLE_FAILURE, res.data.message));
        //     }
        // }, (error) => {
        //     dispatch(failure(USER_ROLES.EDIT_USER_ROLE_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        // })
    }
}